module.exports = __webpack_public_path__ + "img/homevisit_03.93c610de.svg";